import { useState } from "react"
import NewActionButton from "~/components/Common/NewActionButton"
import NewSort from "~/components/Common/NewSort"
import NewTabs from "~/components/Common/NewTabs"
import DocHeader from "~/components/Docs/DocHeader"
import AddTranslationDialog from "~/components/Translations/AddTranslationDialog"
import TranslationsList from "~/components/Translations/TranslationsList"
import { DOC_TABS } from "~/constants/docs"
import { DOC_OPTIONS } from "~/constants/translations"
import { useGetDoc } from "~/hooks/useGetDoc"
import useSortTranslations from "~/hooks/useSortTranslations"

const Translations = ({ routes = [], ...rest }) => {
  const docId = rest?.match?.params?.doc_id
  const { data: doc } = useGetDoc(docId)
  const [openDialog, setOpenDialog] = useState(false)
  const [translation, setTranslation] = useState({})
  const { sortedTranslations, sort, setSort } = useSortTranslations(doc)

  const updateTranslation = (t) => {
    setTranslation(t)
    setOpenDialog(true)
  }

  const closeDialog = () => {
    setTranslation({})
    setOpenDialog(false)
  }

  return (
    <div className="h-full overflow-auto">
      <DocHeader doc={doc} onSubmitHandler={() => {}} isLoading={false} />
      <NewTabs doc={doc} tabs={DOC_TABS} />
      <div className="p-4">
        <div className="flex justify-between items-center">
          <NewActionButton
            title="new translation"
            action={() => setOpenDialog(true)}
            haveIcon={true}
          />
          <NewSort
            options={DOC_OPTIONS}
            sort={sort}
            setSort={setSort}
            data={doc?.translations ?? []}
          />
        </div>
        <TranslationsList
          translations={sortedTranslations}
          updateTranslation={updateTranslation}
          typeData={{
            type_id: rest?.match?.params?.doc_id,
            type: "docs",
          }}
          options={DOC_OPTIONS}
        />
        <AddTranslationDialog
          open={openDialog}
          closeDialog={closeDialog}
          translation={translation}
          typeData={{
            type_id: rest?.match?.params?.doc_id,
            type: "docs",
          }}
          translations={sortedTranslations}
        />
      </div>
    </div>
  )
}
export default Translations
